/** Light/dark theme state: a `data-theme` attribute + `localStorage`. */

export type Theme = 'light' | 'dark';

/** `localStorage` key. Changing it loses every user's choice — don't. */
export const THEME_STORAGE_KEY = 'ops-theme';

export const THEME_DEFAULT: Theme = 'light';

/** Stored value -> theme, falling back to the iSmart default (light). */
export function resolveTheme(stored: string | null | undefined): Theme {
  return stored === 'dark' ? 'dark' : THEME_DEFAULT;
}

/** Applies the theme to the document root (and persists it). */
export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Private mode / storage disabled: the theme still applies for this page.
  }
}

export function readStoredTheme(): Theme {
  try {
    return resolveTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return THEME_DEFAULT;
  }
}

export function toggleTheme(theme: Theme): Theme {
  return theme === 'dark' ? 'light' : 'dark';
}
